export default __webpack_public_path__ + "static/media/Sarah2.486ee880.jpg";